import { render, staticRenderFns } from "./ClockHeader.vue?vue&type=template&id=8f29845a&scoped=true&"
import script from "./ClockHeader.vue?vue&type=script&lang=js&"
export * from "./ClockHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f29845a",
  null
  
)

export default component.exports